import PartInfoModal from './part-info-modal';

export default PartInfoModal;
